import React, { FC, PropsWithChildren } from "react";
import { DateTime } from "@/components/common/DateTime";
import { Button } from "@/components/ui/button";
import { ArrowDownFromLine } from "lucide-react";
import { useToggle } from "@/hooks/useToggle";
import { cn } from "@/lib/utils";

export const SettlementSummaryBar: FC<PropsWithChildren> = ({ children }) => {
  const { value: showStatCards, handleToggle } = useToggle(true);

  return (
    <div className="flex flex-col gap-2 bg-neutral-50 rounded-lg p-4">
      <div className="flex items-center justify-between">
        <DateTime
          className="flex-row gap-2 justify-end"
          timeClassName="text-base text-stone font-semibold"
        />

        <Button variant="ghost" onClick={handleToggle}>
          <ArrowDownFromLine
            className={cn(
              "size-4 text-dark-gray transition-transform",
              !showStatCards && "rotate-180",
            )}
          />
        </Button>
      </div>

      {showStatCards && <div className="flex gap-4">{children}</div>}
    </div>
  );
};
